/**
 * Thin seam for the side effects that today live inside listener `tap()` operators
 * (`Store.dispatch(...)`, HTTP triggers). Keeping it behind an interface means the listener
 * factories (Phase 4) don't import `@ngxs/store` directly and stay unit-testable.
 *
 * The host provides a concrete implementation (wrapping the real NGXS `Store`) via
 * {@link AUTO_CALC_CONFIGS_TOKEN}. Skeleton-only for now; wired up in Phase 4.
 */
export interface AutoCalcDispatcher {
  /** Dispatch a host action (e.g. an NGXS action) as a calc side effect. */
  dispatch(action: unknown): void;
}

/** No-op dispatcher used when a host supplies none (tests, calc-only contexts). */
export class NoopAutoCalcDispatcher implements AutoCalcDispatcher {
  dispatch(_action: unknown): void {
    /* intentionally empty */
  }
}
